import { modalClassificacoesPorMesStyles } from './ModalClassificacoesPorMes.style'

export function modalClassificacoesPorMesIO() {
  return {
    styles: modalClassificacoesPorMesStyles
  }
}

export type ModalClassificacoesPorMesIO = ReturnType<typeof modalClassificacoesPorMesIO>
